// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-15dd1d45] {\r\n  font-size: 1.714rem !important;\r\n  font-weight: 500;\n}\n[dir] label[data-v-15dd1d45] {\r\n  margin-bottom: 0;\n}\n.repeater-form[data-v-15dd1d45] {\r\n  overflow: visible;\r\n  transition: 0.35s height;\n}\n[dir] .repeater-form[data-v-15dd1d45] {\r\n  margin: 0;\r\n  padding: 0;\n}\n[dir] .repeater-form > .row[data-v-15dd1d45] {\r\n  margin-bottom: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
